<template>
  <div>
    <div class="bg_div">
      <div class="login_div">
        <div class="left">
          <img src="../assets/stylus/image/logo.png" />
        </div>
        <div class="right">
          <p class="active_p" @click="handleSelect">登录后台系统</p>
          <p
            style="padding-left: 0;padding-right: 0;margin-right: 12px;"
            @click="about('/about')"
            :class="router_type == 'about' ? 'active_home' : ''"
          >
            关于程果
          </p>
          <p
            style="padding-left: 0;padding-right: 0;margin-right: 12px;"
            :class="router_type == 'study' ? 'active_home' : ''"
          >
            <a target="_blank" href="http://oj.cgyounger.com/">
              信奥学习
            </a>
          </p>
          <p
            style="padding-left: 0;padding-right: 0;margin-right: 12px;"
            @click="about('/about')"
            :class="router_type == 'match' ? 'active_home' : ''"
          >
            赛事中心
          </p>
          <p
            style="padding-left: 0;padding-right: 0;margin-right: 12px;"
            @click="about('/about')"
            :class="router_type == 'Programming community' ? 'active_home' : ''"
          >
            编程社区
          </p>
          <p
            style="padding-left: 0;padding-right: 0;margin-right: 12px;"
            @click="about('/login')"
            :class="router_type == 'login' ? 'active_home' : ''"
          >
            首页
          </p>
        </div>
      </div>

      <img class="bg_div_img" src="../assets/stylus/image/banner1.jpg" />
    </div>

    <fotter></fotter>

    <el-dialog
      :visible.sync="login_dialog"
      width="30%"
      :close-on-click-modal="false"
    >
      <span slot="title" class="dialog-footer">
        <el-tabs v-model="activeName">
          <el-tab-pane label="登录" name="login">
            <el-form
              ref="form_ref"
              :model="login_form"
              :rules="rules"
              label-width="0px"
              class="login_from"
            >
              <!-- 用户名 -->
              <el-form-item prop="username">
                <el-input
                  v-model="login_form.username"
                  prefix-icon="iconfont icon-user"
                  placeholder="请输入用户名"
                >
                  <i slot="prefix" class="el-icon-user"></i>
                </el-input>
              </el-form-item>
              <!-- 密码 -->
              <el-form-item prop="password">
                <el-input
                  v-model="login_form.password"
                  type="password"
                  prefix-icon="iconfont icon-3702mima"
                  placeholder="请输入密码"
                  show-password
                >
                  <i slot="prefix" class="el-icon-goods"></i>
                </el-input>
              </el-form-item>
              <!-- 按钮区域 -->
              <el-form-item class="but"></el-form-item>
            </el-form>
          </el-tab-pane>

          <el-tab-pane label="注册" name="register">
            <el-form
              ref="form_register"
              :model="register_form"
              :rules="rules"
              label-width="56px"
              class="login_from"
              label-position="right"
            >
              <el-form-item label="头像">
                <el-upload
                  class="avatar-uploader"
                  action="https://jsonplaceholder.typicode.com/posts/"
                  :show-file-list="false"
                  :on-success="handleAvatarSuccess"
                  :before-upload="beforeAvatarUpload"
                >
                  <img
                    v-if="register_form.avatar"
                    :src="register_form.avatar"
                    class="avatar"
                  />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </el-form-item>
              <el-form-item label="用户" prop="username">
                <el-input
                  v-model="register_form.username"
                  placeholder="请输入用户名"
                ></el-input>
              </el-form-item>
              <el-form-item label="密码" prop="password">
                <el-input
                  v-model="register_form.password"
                  type="password"
                  placeholder="请输入密码"
                ></el-input>
              </el-form-item>
              <el-form-item label="昵称">
                <el-input
                  v-model="register_form.nickname"
                  placeholder="请输入昵称"
                ></el-input>
              </el-form-item>
              <el-form-item label="手机">
                <el-input
                  v-model="register_form.phone"
                  placeholder="请输入手机号"
                ></el-input>
              </el-form-item>
              <el-form-item label="email">
                <el-input
                  v-model="register_form.email"
                  placeholder="请输入邮箱"
                ></el-input>
              </el-form-item>
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </span>

      <span slot="footer">
        <el-button
          type="primary"
          @click.native="submitForm"
          @keypress.native.enter="submitForm"
          style="width: 100%; font-weight: 400;"
          >{{ activeName == "login" ? "登录" : "注册" }}</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { register, login, get_userRole_api } from "@/api/login.js";
import { userInfo } from "@/api/home.js";
import { mapGetters } from "vuex";
import store from "../store";
import fotter from "./components/fotter.vue";

export default {
  computed: {
    ...mapGetters(["userInfo"]),
  },
  components: {
    fotter,
  },
  data() {
    return {
      activeIndex: "",
      login_dialog: false,
      rules: {
        // 验证用户名是否合法
        username: [
          {
            required: true,
            message: "请输入登录名称",
            trigger: "blur",
          },
        ],
        // 验证密码是否合法
        password: [
          {
            required: true,
            message: "请输入用户密码",
            trigger: "blur",
          },
        ],
      },
      //登录
      login_form: {
        username: "",
        password: "",
      },
      //注册
      register_form: {
        avatar: "",
        email: "",
        password: "",
      },
      activeName: "login",
      loading: false,
      router_type: this.$route.name,
    };
  },

  created() {},

  methods: {
    handleSelect(key) {
      this.login_dialog = true;
      this.activeName = "login";
      if (this.$refs.form_ref !== undefined) {
        this.$refs.form_ref.clearValidate();
      }
    },

    // 点击登录/注册按钮，
    submitForm() {
      if (this.activeName == "login") {
        this.$refs.form_ref.validate((valid) => {
          if (valid) {
            const loading = this.$loading({
              lock: true,
              text: "Loading",
              spinner: "el-icon-loading",
              background: "rgba(0, 0, 0, 0.7)",
            });

            login(this.login_form)
              .then((res) => {
                userInfo().then((response) => {
                  // 获取用户角色
                  get_userRole_api().then((value) => {
                    if (value.data.length) {
                      this.$message.success("登录成功！");
                      response.data.user_role = value.data;
                      console.log(value.data);
                      window.sessionStorage.setItem("token", res.data.token);
                      store.dispatch(
                        "current/campus",
                        value.data[0].Domain.Name
                      );
                    } else {
                      response.data.user_role = false;
                      this.$message.error("该用户未分配角色，禁止访问！");
                      loading.close();
                    }

                    if (response.data.user_role[0].Domain.Name == "ANY") {
                      this.$router.push({ path: "/user" });
                    } else {
                      this.$router.push({ path: "/home" });
                    }
                    loading.close();
                    store.dispatch("user/userInfo", response.data);
                  });
                });
              })
              .catch(() => {
                loading.close();
              });
          }
        });
      } else {
        this.$refs.form_register.validate((valid) => {
          if (valid) {
            const loading = this.$loading({
              lock: true,
              text: "Loading",
              spinner: "el-icon-loading",
              background: "rgba(0, 0, 0, 0.7)",
            });

            //注册接口
            register(this.register_form)
              .then((res) => {
                loading.close();
                this.$message.success("注册成功！");
                this.register_form = {};
              })
              .catch(() => {
                loading.close();
              });
          }
        });
      }
    },

    handleAvatarSuccess(res, file) {
      this.register_form.avatar = URL.createObjectURL(file.raw);
    },

    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },

    //跳转页面
    about(type) {
      this.$router.push({ path: type });
    },
  },
};
</script>

<style lang="stylus" scoped>
.login_from {
  margin-top: 12px;
}

>>>.el-dialog__body {
  padding: 0;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 60px;
  height: 60px;
  line-height: 60px;
  text-align: center;
  border: 1px solid #eee;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.bg_div {
  height: 700px;
  background: #ccc;
  position: relative;
  overflow: hidden;

  .login_div {
    position: fixed;
    top: 0;
    width: 100%;
    color: #000;
    padding: 0px 16px 0px 16px;
    font-size: 12px;
    z-index: 3;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background:#fff;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
    p {
      float: right;
      cursor: pointer;
      padding: 10px;
    }

    .active_p {
      border-radius: 20px;
      background: #ff8d1a;
      margin-left: 12px;
      color:#000;
    }

    .active_p {
      color: #fff;
    }

    .left {
     img {
       width:30%;
     }
  }
  }

  .text_div {
    position: absolute;
    left: 14%;
    top: 36%;
    z-index: 3;
    color: #fff;
    font-weight: 300;
    width: 80%;

    h3 {
      font-size: 20px;
      padding: 12px;
    }

    p {
      font-size: 48px;
      padding: 3px;
    }
  }

  .mask {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background: #000;
    opacity: 0.4;
  }

  video {
    width: 100%;
  }

  .bg_div_img {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}

.choice_div {
  background: #fff;
  padding-top: 100px;

  h1 {
    text-align: center;
    line-height: 1.2;
    font-size: 36px;
  }

  .border_div {
    background: #ff8d1a;
    height: 2px;
    width: 50px;
    margin: 20px auto;
  }

  p {
    text-align: center;
    color: #999;
  }

  ul {
    margin-top: 50px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;

    li {
      width: 45%;
      padding: 20px;
      margin-bottom: 26px;

      .top_img {
        width: 90px;
        height: 90px;
        margin: 0 auto;
        border-radius: 45px;
        background: #777;
      }

      h2 {
        text-align: center;
        font-size: 26px;
        font-size: #444;
        padding: 20px;
      }

      p {
        color: #999;
        font-size: 24px;
      }
    }
  }
}

.two_div {
  background: #f8f8f8;
  padding-top: 50px;

  .two_ul {
    li {
      width: 24%;

      p {
        margin-top: 24px;
      }
    }
  }
}

.three_div {
  background: #ffffff;
  padding-top: 50px;
}

.four_div {
  background: #f8f8f8;
  padding-top: 46px;
  padding-bottom: 50px;
}

.fourBottom_div {
  width: 80%;
  padding: 20px;
  background: #fff;
  margin: 0px auto;
  display: flex;
  justify-content: space-around;
  border-radius: 6px;

  .left {
    width: 40%;
    overflow: hidden;
    border: 1px solid #ff8d1a;
  }

  .right {
    width: 50%;

    h4 {
      font-size: 30px;
      color: #444;
    }

    p {
      text-align: left;
      color: #8f8f8f;
      font-size: 16PX;
      margin-top: 30px;
      text-indent: 2em;
      line-height: 22px;
    }
  }
}

.five_div {
  background: #fff;
  padding-top: 44px;

  .left {
    border: none;
  }

  .right {
    ul {
      margin-top: 0;

      li {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;

        img {
          width: 66px;
          height: 66px;
          border-radius: 33px;
        }

        h3 {
          margin-left: 20px;
          line-height: 30px;
          font-size: 24px;
          color: #8f8f8f;
        }
      }
    }
  }
}

.cooperation_ul {
  width: 90%;
  margin: 0 auto;

  li {
    width: 24.5% !important;
    padding: 12px;
    background: #eee;
    border-radius: 4px;

    img {
      margin: 0 auto;
    }
  }
}

.left_carousel {
  float: left;
  width: 40%;
  height: 100%;
  margin-left: 6%;
  padding: 20px;
}

.right_carousel {
  float: right;
  width: 40%;
  height: 100%;
  margin-right: 6%;
  padding: 20px;
}

.el-carousel {
  margin-top: 100px;
  padding-bottom: 34px;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n+1) {
  background-color: #d3dce6;
}

.active_home {
  border-bottom: 2px solid #ff8d1a;
}
</style>

<style scoped lang="stylus">
@thePink :#e84d49;
.typer {
  margin-top: 2%;
  box-sizing: border-box;
}

.typer .typer-content {
  font-weight: bold;
  font-size: 50px;
  display: flex;
  flex-direction: row;
  letter-spacing: 2px;
}

.typer-dynamic {
  position: relative;
}

.cut {
  color: @thePink;
}

.typer-cursor {
  position: absolute;
  height: 100%;
  width: 3px;
  top: 0;
  right: -10px;
  background-color: @thePink;
  animation: flash 1.5s linear infinite;
}
</style>
